export class Controller {

    /** @ngInject */
    constructor(AccountsResource, Alert, GroupsResource) {
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
        this.accounts = [];
        this.isLoading = true;
        const {applicationId, companyId, groupId} = this.resolve;

        this.GroupsResource
            .getAllAccountsForCompanyAndGroupAndApplication(companyId, groupId, applicationId)
            .then(accounts => this.accounts = accounts)
            .finally(() => this.isLoading = false)
    }

    save(accountId, password) {
        const {companyId, applicationId} = this.resolve;
        return this.AccountsResource
            .setPasswordForAccount(companyId, applicationId, accountId, password)
            .then(() => this.accounts.find(a => a.id === accountId))
            .then(a => a.password = password)
            .then(() => this.Alert('success', 'company.manage-application.users.manage-epm-credentials.saved'))
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/epm-credentials/epm-credentials.controller.js